import React from 'react'
import List from '../pages/list'

export const PagesLegallList = (props) => <List {...props} filter={{ collection: 'legal' }} title="Pages Promises" />

export default PagesLegallList
